"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.profession.list': 'Professions',
    'route.profession.create': 'Add Profession',
    'route.profession.edit': 'Edit Profession',
};
